import type { IExtraService, IExtraServices } from '@/types';
import type { ComponentWithAs, IconProps } from '@chakra-ui/react';
import { extraServices } from '../constants';

interface IExtraServiceElement {
  description: string;
  icon: ComponentWithAs<'svg', IconProps>;
  id: string;
  label: string;
  name: string;
}

const isIncluded = (el: IExtraService): boolean => el.isIncluded;
const isNotIncluded = (el: IExtraService): boolean => !el.isIncluded;

const mergeServices = (
  s1: IExtraServiceElement,
  s2: IExtraService
): IExtraServiceElement & IExtraService => ({ ...s1, ...s2 });

interface IUseExtraServicesReturnValue {
  added: (IExtraServiceElement & IExtraService)[];
  available: (IExtraServiceElement & IExtraService)[];
}

export const useExtraServices = (services?: IExtraServices): IUseExtraServicesReturnValue => {
  if (!services) return { added: [], available: [] };

  const quoteServices = extraServices.map((el) =>
    mergeServices(el, services[el.id as keyof IExtraServices])
  );

  const added = quoteServices.filter(isIncluded).reverse();
  const available = quoteServices.filter(isNotIncluded);
  return { added, available };
};
